import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import integrators from "../../../constants/exemptedIntegrators";
import {
  ACTIONTYPES,
  useStoreDispatch,
} from "../../../context/CreateStoreContext";
import Create from "../../Create/Create";
import Error403 from "../../ErrorPages/Error403";
import { Spin } from "antd";

export async function loader({ request }) {
  const url = new URL(request.url);
  const integratorId = url.searchParams.get("integrator_id");

  const isExempted = integrators.some(
    (integrator) => integrator.id === integratorId,
  );

  const formCompleted = localStorage.getItem("integratorFormCompleted") === "1";
  console.log(typeof formCompleted);

  return { integratorId, isExempted, formCompleted };
}

export default function Onboarding() {
  const { integratorId, isExempted, formCompleted } = useLoaderData();
  const dispatch = useStoreDispatch();
  const [renderForm, setRenderForm] = useState(false);

  useEffect(() => {
    // if (formCompleted) {
    //   // Just in case user refresh the browser and did not yet completed/submitted the form
    //   dispatch({ type: ACTIONTYPES.CLEAR_FORM_STATES });
    // }

    // Always clear form state
    dispatch({ type: ACTIONTYPES.CLEAR_FORM_STATES });

    dispatch({
      type: ACTIONTYPES.INTEGRATOR,
      data: { id: integratorId, isExempted },
    });

    // this will give ample time to clear the form
    const timer = setTimeout(() => {
      setRenderForm(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!isExempted) {
    return <Error403 />;
  }

  if (!renderForm) {
    return <Spin fullscreen />;
  }

  return <Create />;
}
